import { NgOptimizedImage } from '@angular/common';
import { Component, inject, input, InputSignal, Signal, viewChild } from '@angular/core';
import { LanguageService } from '@app/shared/services/shared/language.service';
import { Language } from '@app/shared/types/enums/language.type';
import { AvailableLanguagesOptions } from '@app/shared/types/models/shared/available-languages-options';
import { UiSelectComponent } from '@app/shared/ui/select/ui-select.component';
import { ProffeoUiSelectOption } from '@app/shared/ui/types/select.types';

@Component({
  selector: 'proffeo-lang-toggle',
  templateUrl: './lang-toggle.component.html',
  imports: [NgOptimizedImage, UiSelectComponent]
})
export class LangToggleComponent {
  private readonly languageService: LanguageService = inject(LanguageService);
  private readonly languageSelect: Signal<UiSelectComponent<Language>> = viewChild.required(UiSelectComponent);

  protected readonly languageOptions: ProffeoUiSelectOption<Language>[] = AvailableLanguagesOptions;
  protected readonly currentLanguage: Signal<Language> = this.languageService.currentLocale;

  public readonly expanded: InputSignal<boolean> = input<boolean>(false);

  protected onSelectLanguage(language: Language | Language[] | null): void {
    if (language === null || Array.isArray(language)) {
      return;
    }

    this.languageService.setLanguage(language);
  }

  public openMenu($event: PointerEvent): void {
    this.languageSelect().openMenu();
    $event.stopPropagation();
  }
}
